import useAmericanIssuer from "components/company/v3/context/hooks/useAmericanIssuer";
import { FormattedMessage } from "react-intl";

export default function AmericanExternalLinks() {
  const { investorRelationsHref, websiteHref, edgarHref } = useAmericanIssuer();

  return (
    <div className="flex items-center divide-x divide-gray-200 *:px-2 first:*:pl-0 last:*:pr-0">
      {websiteHref && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={websiteHref}
          className="text-sm font-medium text-blue-600 hover:underline"
        >
          <FormattedMessage defaultMessage="Website" id="JkLHGw" />
        </a>
      )}

      {investorRelationsHref && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={investorRelationsHref}
          className="text-sm font-medium text-blue-600 hover:underline"
        >
          <FormattedMessage defaultMessage="Site de RI" id="LSwTIE" />
        </a>
      )}

      {edgarHref && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={edgarHref}
          className="text-sm font-medium text-blue-600 hover:underline"
        >
          <FormattedMessage defaultMessage="SEC" id="1mNkDf" />
        </a>
      )}
    </div>
  );
}
